import EventService from '../services/event.service';
import { Constants } from '../cfg/constants';

export const event = {
  namespaced: true,
  state: {
    event: {},
    lastEvent: {},
    is_room_owner: false,
    guest: {
      name: "Guest",
      language: Constants.DEFAULT_LANGUAGE,
      voice: "male"
    },
    mode: {
      mode: "default",
      background: ""
    },
    preRoomPassed: false,
    settings: {
      speech_mode: "custom_pause", // custom_pause, live_translate
      partial_playback_mode: "character", // character, word
      show_original_with_translation: true,
      asr_partial_results_stability: "medium",
      asr_segment_min_words: 5,
      asr_segmenter_mode: "punctuation", // stability, phrase, sentence, punctuation
      asr_segment_max_duration_sec: 10, // stability mode only
      partial_buffer_word_threshold: 3,
      partial_type_interval_ms: 22,
      final_transcript_fade_ms: 2500,
      transcript_scroll_speed: 72,
      tts_muted: true,
      tts_speed: 110,
      tts_same_muted: false,
      profanity_filter: true,
      chroma_overlay_color: "#00FF00",
      is_autostop_enabled: true,
      autostop_timeout: 1800,
      fontSize: 20,
      transcriptAlign: "left", // left, center, right
      transcriptWidth: "wide", // wide, narrow
      transcriptFont: "sans", // sans, serif (see Constants.CAPTION_FONTS)
      transcriptTheme: "dark" // dark, light
    },
    defaults: {
      speech_mode: "custom_pause", // custom_pause, live_translate
      partial_playback_mode: "character", // character, word
      show_original_with_translation: true,
      asr_partial_results_stability: "medium",
      asr_segment_min_words: 5,
      asr_segmenter_mode: "punctuation", // stability, phrase, sentence, punctuation
      asr_segment_max_duration_sec: 10, // stability mode only
      partial_buffer_word_threshold: 3,
      partial_type_interval_ms: 22,
      final_transcript_fade_ms: 2500,
      transcript_scroll_speed: 72,
      tts_muted: true,
      tts_speed: 110,
      tts_same_muted: true,
      profanity_filter: true,
      chroma_overlay_color: "#00FF00",
      is_autostop_enabled: true,
      autostop_timeout: 1800,
      fontSize: 20,
      transcriptAlign: "left", // left, center, right
      transcriptWidth: "wide", // wide, narrow
      transcriptFont: "sans", // sans, serif (see Constants.CAPTION_FONTS)
      transcriptTheme: "dark" // dark, light
    }
  },
  actions: {
    create({ commit }, params) {
      let event = {
        title: params.title,
        is_participating_disabled: params.is_participating_disabled,
        is_transcript_allowed: params.is_transcript_allowed
      };
      return EventService.create(event).then(
        response => {
          commit('setEvent', response.data.result);
          commit('setLastEvent', response.data.result);
          commit('setIsRoomOwner', true);
          commit('setAutostopEnabled', params.is_autostop_enabled);
          commit('setAutostopTimeout', params.autostop_timeout);
          commit('event/setSpeechMode', params.speech_mode, { root: true });
          commit('setProfanityFilter', params.profanity_filter);
          commit('setTtsSameMuted', params.tts_same_muted);
          commit('setTtsSpeed', params.tts_speed);
          return Promise.resolve(response.data.result);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    join({ commit, rootState }, roomcode) {
      const params = {
        room_code: roomcode
      };

      params.is_host = rootState.auth.authorized;

      return EventService.join(params).then(
        response => {
          commit('setEvent', response.data.result);
          commit('setLastEvent', response.data.result);
          //commit('setIsRoomOwner', false);
          return Promise.resolve(response.data.result);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    close({ commit }) {
      commit('setEvent', null);
      commit('setIsRoomOwner', null);
    },

    setGuestProfile({ commit }, guest) {
      commit('setGuest', guest);
      commit('setPrePassed', true);
      return Promise.resolve(guest);
    },
    saveSettings({ commit }, settings) {
      commit('setSettings', settings);
      return Promise.resolve(settings);
    },
    saveSpeechMode({ commit }, mode) {
      commit('setSpeechMode', mode);
    }
  },
  getters: {
    getGuestProfile(state) {
      return state.guest;
    }
  },
  mutations: {
    setEvent(state, event) {
      state.event = event;
    },
    setLastEvent(state, event) {
      state.lastEvent = {
        code: event.room_code,
        status: event.status
      };
    },
    setIsRoomOwner(state, is_room_owner) {
      state.is_room_owner = is_room_owner
    },
    setGuest(state, guest) {
      state.guest = guest;
    },
    setGuestLanguage(state, language) {
      state.guest.language = language;
    },
    setSettings(state, settings) {
      if (!settings) {
        Object.assign(state.settings, state.defaults);
      } else {
        state.settings = settings;
      }
    },
    setPrePassed(state, bool) {
      state.preRoomPassed = bool;
    },
    setAutostopEnabled(state, bool) {
      state.settings.is_autostop_enabled = bool;
    },
    setAutostopTimeout(state, num) {
      state.autostop_timeout = num;
    },
    setSpeechMode(state, mode) {
      state.settings.speech_mode = mode;
    },
    setProfanityFilter(state, bool) {
      state.settings.profanity_filter = bool;
    },
    setTtsSameMuted(state, bool) {
      state.settings.tts_same_muted = bool;
    },
    setTtsSpeed(state, speed) {
      state.settings.tts_speed = speed;
    },
    setFontSize(state, size) {
      state.settings.fontSize = size;
    },
    setShowOriginalWithTranslation(state, show) {
      state.settings.show_original_with_translation = show;
    },
    setTranscriptAlign(state, align) {
      state.settings.transcriptAlign = align;
    },
    setTranscriptWidth(state, width) {
      state.settings.transcriptWidth = width;
    },
    setTranscriptFont(state, font) {
      state.settings.transcriptFont = font;
    },
    setTranscriptTheme(state, theme) {
      state.settings.transcriptTheme = theme;
    },
    setEventTitle(state, title) {
      if (state.event) {
        state.event.title = title;
      }
    }
  }
}
